/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ type: NonNullable<unknown> }} Plan_Unknown_Payment_TypeInputs */

const en_plan_unknown_payment_type = /** @type {(inputs: Plan_Unknown_Payment_TypeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Unknown payment method type ${i?.type}`)
};

const es_plan_unknown_payment_type = /** @type {(inputs: Plan_Unknown_Payment_TypeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tipo de método de pago desconocido ${i?.type}`)
};

/**
* | output |
* | --- |
* | "Unknown payment method type {type}" |
*
* @param {Plan_Unknown_Payment_TypeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_unknown_payment_type = /** @type {((inputs: Plan_Unknown_Payment_TypeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Unknown_Payment_TypeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_unknown_payment_type(inputs)
	return en_plan_unknown_payment_type(inputs)
});